/**
 * @desc service that provides common functionalite for full page charts
 * namely: Inventory Burnoff and POs to Action: 12 months
 */

(function() {
	'use strict';

	angular
		.module('services', []);
})();
